export default __webpack_public_path__ + "vendor/scripts/jquery.flot.animator.min.js";